import React from "react";

const SkeletonCard = () => (
  <div className="bg-white rounded-lg border border-slate-200 overflow-hidden animate-pulse">
    <div className="bg-gray-200 p-3 h-9 border-b border-slate-200" />
    <div className="p-3 space-y-3">
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-3 bg-gray-200 rounded w-3/4" />
          <div className="h-3 bg-gray-200 rounded w-1/2" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="space-y-1">
            <div className="h-2 bg-gray-200 rounded w-1/2" />
            <div className="h-3 bg-gray-200 rounded w-3/4" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

const SkeletonTableCard = () => (
  <div className="bg-white rounded-lg border border-slate-200 overflow-hidden animate-pulse">
    <div className="bg-gray-200 p-3 h-9 border-b border-slate-200" />
    <div className="p-3 space-y-2">
      {[1, 2, 3].map((i) => (
        <div key={i} className="flex gap-4">
          <div className="h-3 bg-gray-200 rounded w-8" />
          <div className="h-3 bg-gray-200 rounded w-1/3" />
          <div className="h-3 bg-gray-200 rounded w-1/2" />
        </div>
      ))}
    </div>
  </div>
);

const SkeletonServiceCard = () => (
  <div className="bg-white border border-slate-200 rounded-lg overflow-hidden animate-pulse">
    <div className="p-3 flex justify-between items-center border-b border-slate-200 bg-gray-50">
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-lg bg-gray-200" />
        <div className="space-y-1">
          <div className="h-3 bg-gray-200 rounded w-40" />
          <div className="h-2 bg-gray-200 rounded w-24" />
        </div>
      </div>
      <div className="flex gap-2">
        <div className="h-6 w-16 bg-gray-200 rounded" />
        <div className="h-6 w-14 bg-gray-200 rounded" />
      </div>
    </div>
    <div className="p-3 grid grid-cols-2 md:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((j) => (
        <div key={j} className="space-y-1">
          <div className="h-2 bg-gray-200 rounded w-2/3" />
          <div className="h-3 bg-gray-200 rounded w-3/4" />
        </div>
      ))}
    </div>
  </div>
);

const AdvancePreAuthDetailsSkeleton = () => (
  <div className="w-full px-6 py-2 space-y-2">
    {/* Three info cards: Patient, Coverage, Provider */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>

    {/* Two table cards: Supporting Info & Diagnoses */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
      <SkeletonTableCard />
      <SkeletonTableCard />
    </div>

    {/* Service / Items cards */}
    <div className="space-y-2">
      <SkeletonServiceCard />
      <SkeletonServiceCard />
    </div>
  </div>
);

export default AdvancePreAuthDetailsSkeleton;
